import ViewedProductsContainer from "containers/viewedProducts/viewedProducts";
import { useInfiniteQuery } from "react-query";
import { useTranslation } from "react-i18next";
import productService from "services/product";
import LoadMore from "components/button/load-more";
import { useAppSelector } from "hooks/useRedux";
import { selectCurrency } from "redux/slices/currency";
import SEO from "components/seo";
import SettingsContainer from "containers/settings/settings";

export default function ViewedProductsPage() {
  const { i18n, t } = useTranslation();
  const currency = useAppSelector(selectCurrency);
  const { data, isLoading, hasNextPage, isFetchingNextPage, fetchNextPage } =
    useInfiniteQuery({
      queryKey: ["viewedProducts", i18n.language, currency?.id],
      queryFn: ({ pageParam = 1 }) =>
        productService.getViewed({
          page: pageParam,
          lang: i18n.language,
          currency_id: currency?.id,
          perPage: 10,
        }),
      getNextPageParam: (lastPage: any) => {
        if (lastPage?.meta?.current_page < lastPage?.meta?.last_page) {
          return lastPage?.meta?.current_page + 1;
        }
        return undefined;
      },
    });

  const extractedData = data?.pages?.flatMap((page) => page?.data || []) || [];

  return (
    <>
      <SEO title={t("viewed.products")} />
      <SettingsContainer>
        <ViewedProductsContainer data={extractedData} loading={isLoading} />
        {hasNextPage && (
          <div style={{ marginTop: "20px" }}>
            <LoadMore
              loading={isFetchingNextPage}
              onClick={() => fetchNextPage()}
            >
              {t("load.more")}
            </LoadMore>
          </div>
        )}
      </SettingsContainer>
    </>
  );
}
